import React from "react";
import { FlexDiv } from "../../ui";
import theme from "../../../util/theme";
import LeftLaurel from "../../../content/img/homepage/left-laurel.svg";
import AppleIcon from "../../../content/assets/icons/apple-logo-light-grey.svg";
import GooglePlayIcon from "../../../content/assets/icons/google-play-logo-colored.png";
import ReviewsIcon from "../../../content/assets/review-stars.svg";
import styled, { css } from "styled-components";
import { mobileSize } from "../../../util/variables";

enum PLATFORM {
  Apple = "Apple",
  Google = "Google Play",
  Reviews = "Reviews",
}

const AWARDS_DATA = [
  {
    type: PLATFORM.Google,
    text: "APP OF THE YEAR",
  },
  {
    type: PLATFORM.Apple,
    text: "ESSENTIAL EDUCATION APP",
  },
  {
    type: PLATFORM.Reviews,
    text: "OVER 50K REVIEWS",
  },
];

interface AwardProps {
  type: PLATFORM;
  text: string;
  dark?: boolean;
  darkLaurel?: boolean;
}

interface AwardsProps {
  dark?: boolean;
  darkLaurel?: boolean;
}

export const AwardsCompact = ({ dark, darkLaurel }: AwardsProps) => {
  return (
    <FlexDiv justify="center" gap={24} mobileGap={0}>
      {AWARDS_DATA.map(award => (
        <Award key={award.text} dark={dark} darkLaurel={darkLaurel} {...award} />
      ))}
    </FlexDiv>
  );
};

const Award: React.FC<AwardProps> = ({ type, text }) => {
  const getPlatformImg = () => {
    switch (type) {
      case PLATFORM.Apple:
        return AppleIcon;
      case PLATFORM.Google:
        return GooglePlayIcon;
      case PLATFORM.Reviews:
        return ReviewsIcon;
      default:
        return null;
    }
  };

  return (
    <FlexDiv direction="column" align="center" gap={8}>
      <FlexDiv justify="flex-start" align="center" gap={8} mobileGap={4}>
        <Laurel
          src={LeftLaurel}
          // dark={darkLaurel}
          alt="left laurel"
          height={49}
          width={20}
        />
        <PlatformImg
          src={getPlatformImg()}
          width={36}
          height={36}
          alt={text}
        // dark={dark}
        />
        <Laurel
          src={LeftLaurel}
          // dark={darkLaurel}
          alt="right laurel"
          height={49}
          width={20}
          style={{ transform: "scaleX(-1)" }}
        />
      </FlexDiv>
      <AwardText>{text}</AwardText>
    </FlexDiv>
  );
};

const PlatformImg = styled.img<{ dark?: boolean }>`
  ${props =>
    props.dark &&
    css`
      filter: brightness(0);
    `}
  @media ${mobileSize} {
    width: 26px;
    height: 26px;
  }
  pointer-events: none;
`;

const AwardText = styled.p<{ dark?: boolean }>`
  max-width: 13ch;
  margin: 0;
  margin-top: 4px;

  font-size: 16px;
  font-weight: 500;
  line-height: 1.2;
  font-family: ${theme.SECONDARY_FONT};
  text-transform: uppercase;
  text-align: center;
  color: ${theme.BLACK_COLOR};
  @media ${mobileSize} {
    font-size: 12px;
    max-width: 110px;
  }
`;

const Laurel = styled.img<{ dark?: boolean }>`
  filter: ${props => (props.dark ? "brightness(0)" : "none")};
  pointer-events: none;
  @media ${mobileSize} {
    width: 16px;
    height: 36px;
  }
`;
